import React, { useState, useRef } from 'react';

import { getString } from '../../../../helpers/styles';

export default function CommunityNewTopicPopupContent({
  onClose,
  addTopic,
  groupXuid
}) {
  const form = useRef();
  const subjectInput = useRef();
  const descriptionInput = useRef();
  const [topicImage, setTopicImage] = useState();
  const [formIsValid, setFormIsValid] = useState(false);

  return (
    <>
      <div className="communityTopicList-new-topic-popup-header">
        <h4 className="communityTopicList-new-topic-popup-header-title">
          Nieuw onderwerp
        </h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body">
        <form ref={form} className="communityTopicList-new-topic-popup-form">
          <input
            onChange={() => validate()}
            required
            ref={subjectInput}
            placeholder="Titel"
            className="communityTopicList-new-topic-title"
            maxLength="100"
          />

          <textarea
            onChange={() => validate()}
            required
            rows="6"
            placeholder="Text"
            ref={descriptionInput}
            className="communityTopicList-new-topic-text"
          />

          <input
            name="image"
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => {
              const [file] = e.target.files;
              setTopicImage(URL.createObjectURL(file));
            }}
          />

          {topicImage && (
            <img
              className="communityTopicList-new-topic-image"
              src={topicImage}
              alt="topic-image"
            />
          )}
        </form>

        <button
          onClick={() =>
            addTopic({
              variables: {
                userGroupXuid: groupXuid,
                subject: subjectInput.current.value.trim(),
                description: descriptionInput.current.value.trim(),
                status: 'ACTIVE',
                visibility: 'PUBLIC'
              }
            }).then(() => window.scrollTo(0, 0))
          }
          className={getString([
            {
              value: 'popup-button popup-button-primary',
              condition: true
            },
            {
              value: 'popup-button-disabled',
              condition: !formIsValid
            }
          ])}
        >
          Plaatsen
        </button>
      </div>
    </>
  );

  function validate() {
    setFormIsValid(form.current.checkValidity());
  }
}
